// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2iRIE","fileBtn":"File_fileBtn__2KReC","closeBtn":"File_closeBtn__32N8r","fileSelected":"File_fileSelected__1PzvS","disabled":"File_disabled__2gxfS"};